import {
	MESSAGE_LIST_GENERIC_ACTIVITY_LIST_SORT,
	MESSAGE_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE,
} from 'src/stores/messageList/localStorageKeys';
import { TSMap } from 'typescript-map';

import { DateRangeSelection } from 'src/models/common';
import { FilterBoxes, FilterUsers } from 'src/models/filter';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { MessageListItem } from 'src/models/messageList';
import { PreconfiguredTimeRanges } from 'src/models/miniCalendar';
import { SerializedQuery } from 'src/models/query';

interface MessageListStateInterface {
	activeQueryIdentifierByListType: TSMap<ActivityListTypeEnum, string>;
	dateFilter: DateRangeSelection | string;
	dateTimeRangeFilter: PreconfiguredTimeRanges;
	directionFilter: 'combined' | 'in' | 'out';
	filterBoxes: Array<FilterBoxes>;
	filterUsers: Array<FilterUsers>;
	filteredBoxIds: Array<string>;
	filteredUsers: Array<FilterUsers>;
	listViewModeLarge: boolean;
	messageListAll: Array<MessageListItem>;
	messageListAllSliced: Map<number, Array<MessageListItem>>;
	messageListAllTotalCount: number;
	messageListMine: Array<MessageListItem>;
	messageListMineSliced: Map<number, Array<MessageListItem>>;
	messageListMineTotalCount: number;
	messageListOpen: Array<MessageListItem>;
	messageListOpenSliced: Map<number, Array<MessageListItem>>;
	messageListOpenTotalCount: number;
	pagination: TSMap<ActivityListTypeEnum, GenericActivityListPagination>;
	queryStoreSubscriptions: Array<SerializedQuery>;
	selectedSharedQueryId: string;
	sort: TSMap<ActivityListTypeEnum, GenericActivityListSort>;
	today: string;
}

function state(): MessageListStateInterface {
	return {
		activeQueryIdentifierByListType: new TSMap<ActivityListTypeEnum, string>([
			[ActivityListTypeEnum.ALL, ''],
			[ActivityListTypeEnum.MINE, ''],
			[ActivityListTypeEnum.OPEN, ''],
		]),
		dateFilter: new Date().toISOString().split('T')[0],
		dateTimeRangeFilter: PreconfiguredTimeRanges.TODAY,
		directionFilter: 'combined',
		filterBoxes: [],
		filterUsers: [],
		filteredBoxIds: [],
		filteredUsers: [],
		listViewModeLarge:
			localStorage.getItem(MESSAGE_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(MESSAGE_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as 'false' | 'true'
					)
				: true,
		messageListAll: [],
		messageListAllSliced: new Map<number, Array<MessageListItem>>(),
		messageListAllTotalCount: 0,
		messageListMine: [],
		messageListMineSliced: new Map<number, Array<MessageListItem>>(),
		messageListMineTotalCount: 0,
		messageListOpen: [],
		messageListOpenSliced: new Map<number, Array<MessageListItem>>(),
		messageListOpenTotalCount: 0,
		pagination: new TSMap<ActivityListTypeEnum, GenericActivityListPagination>([
			[ActivityListTypeEnum.ALL, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.MINE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.OPEN, { page: 1, rowsPerPage: 100 }],
		]),
		queryStoreSubscriptions: [],
		selectedSharedQueryId: '',
		sort:
			localStorage.getItem(MESSAGE_LIST_GENERIC_ACTIVITY_LIST_SORT) !== null
				? new TSMap<ActivityListTypeEnum, GenericActivityListSort>().fromJSON(
						JSON.parse(localStorage.getItem(MESSAGE_LIST_GENERIC_ACTIVITY_LIST_SORT) as string)
					)
				: new TSMap<ActivityListTypeEnum, GenericActivityListSort>([
						[
							ActivityListTypeEnum.ALL,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.MINE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.OPEN,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
					]),
		today: new Date().toISOString().split('T')[0],
	};
}

export default state;
